import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import React from 'react';

interface IAlertDialogProps {
  open: boolean;
  onPressButton: () => void;
  text: string;
  title: string;
  buttonTitle?: string;
}

export const AlertDialog = (props: IAlertDialogProps) => {
  const { open, onPressButton, buttonTitle, text, title } = props;

  return (
    <Dialog open={open}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onPressButton} color="primary" autoFocus style={{ fontSize: 15, fontFamily: 'Noto Sans, Roboto', fontWeight: 700 }}>
          {buttonTitle ? buttonTitle : 'Okay'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
